export enum FeatureFlags {
  A2C_CROSS_SELL_CAROUSEL = 626,
  A2C_CROSS_SELL_TOP_SELLS_PLAYLIST = 700,
}

export enum ETopSellsRecoEngineNames {
  'CategoryPlaylist1',
  'CategoryPlaylist2',
  'CategoryPlaylist3',
}
